(function () {
    "use strict";

    angular
        .module("PWAPoCApp")
        .controller("SchemaModalController", schemaModalController);

    schemaModalController.$inject = [
        "$q",
        "$scope",
        "$rootScope",
        "$windowInstance",
        "$timeout",
        "routeStop",
        "schema"
    ];

    function schemaModalController(
        $q,
        $scope,
        $rootScope,
        $windowInstance,
        $timeout,
        routeStop,
        schema,
    ) {
        $scope.routeStop = routeStop;
        $scope.schema = schema;
        $rootScope.$broadcast("showBusyIndicator");
        $timeout(() => {
            const survey = new Survey.Model(schema);

            survey.onComplete.add((sender, options) => {
                const schemaObj = JSON.parse(schema);
                schemaObj.answers = sender.data;
                addAnswersToQuestions(schemaObj);
                $windowInstance.close(schemaObj);
            });

            survey.render(document.getElementById("checklistSurveyContainer"));
            $rootScope.$broadcast("hideBusyIndicator");
        }, 1000);

        function addAnswersToQuestions(schemaObj){
            const formKeys = Object.keys(schemaObj.answers);
            if (formKeys.length) {
                formKeys.forEach(key => {
                    for (let i = 0; i < schemaObj.pages.length; i++) {
                        const questionIndex = schemaObj.pages[i].elements.findIndex(e => e.name === key);
                        if (questionIndex >= 0) {
                            schemaObj.pages[i].elements[questionIndex].answer = schemaObj.answers[key];
                            return;
                        }
                    }
                })
            }
        }
    }
})();
